import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useAuth } from "@inbody/keycloak";
import { ExpandMenuItem } from "./ExpandMenuItem.js";
import { LinkMenuItem } from "./LinkMenuItem.js";
const SideMenuItem = memo((props) => {
  const {
    type,
    requireRoleList,
    denyRoleList,
    isCheckCorporateCode,
    rootAdminRole
  } = props;
  const { checkRoles } = useAuth();
  if (requireRoleList) {
    const hasRole = checkRoles(
      requireRoleList,
      isCheckCorporateCode,
      rootAdminRole
    );
    if (!hasRole) {
      return null;
    }
  }
  if (denyRoleList && checkRoles(denyRoleList)) {
    return null;
  }
  if (type === "link") {
    return /* @__PURE__ */ jsx(LinkMenuItem, { ...props });
  }
  return /* @__PURE__ */ jsx(ExpandMenuItem, { ...props });
});
export {
  SideMenuItem
};
